import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import ReactDatePicker, { CalendarContainer } from 'react-datepicker';
import classNames from 'classnames';
import { useContext } from 'react';
import AppContext from 'context/Context';

const DatePickerInput = React.forwardRef(
  ({ value, onClick, disabled, placeholderText }, ref) => {
    const {
      config: { isDark }
    } = useContext(AppContext);
    return (
      <div className="input-group">
        <input
          className={classNames('form-control pe-2', { 'bg-white': !isDark })}
          value={value}
          onClick={onClick}
          ref={ref}
          disabled={disabled}
          readOnly
          placeholder={placeholderText}
        />
        <span className="input-group-text px-2">
          <FontAwesomeIcon icon={faCalendarAlt} onClick={onClick} />
        </span>
      </div>
    );
  }
);

const calendarContainer = ({ className, children }) => {
  return (
    <div style={{ zIndex: 9999 }}>
      <CalendarContainer
        className={classNames('shadow-sm z-99', className)}
        style={{ zIndex: 99 }}
      >
        <div>{children}</div>
      </CalendarContainer>
    </div>
  );
};

const DatePicker = ({
  value,
  onChange,
  placeholderText,
  minDate,
  maxDate,
  ...rest
}) => {
  return (
    <ReactDatePicker
      selected={value || ''}
      onChange={onChange}
      dateFormat="dd/MM/yyyy"
      minDate={minDate}
      maxDate={maxDate}
      style={{ width: '100%', zIndex: 99 }}
      {...rest}
      customInput={<DatePickerInput placeholderText={placeholderText} />}
      calendarContainer={calendarContainer}
      popperModifiers={[
        {
          name: 'zIndexModifier',
          enabled: true,
          phase: 'write',
          fn: ({ state }) => {
            state.styles.popper.zIndex = 10; // Set z-index directly via modifiers
          }
        }
      ]}
      className="z-4"
    />
  );
};
DatePickerInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  placeholderText: PropTypes.string
};

calendarContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date)
};

export default DatePicker;
